import React, { useState, useEffect, useCallback  } from "react";
import "./hr-schedule.css"; // Include custom styling for the modal
import { FaUsers } from "react-icons/fa6";
import { FaUserClock } from "react-icons/fa";
import { IoEye } from "react-icons/io5";
import {Col,Dropdown,Button,Form,Modal,Spinner,Alert,} from "react-bootstrap";
import { IoMdAdd } from "react-icons/io";
import { FaRegEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Importing navigate
import axios from '../../Authservices/axiosInstance';
import _ from "lodash"; // Import lodash for debouncing
export default function HrSchedule() {
  const rowsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [hrData, setHrData] = useState([]);
  const [filteredHrData, setFilteredHrData] = useState([]); // Store filtered data
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedHr, setSelectedHr] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [timingData, setTimingData] = useState({});
  const navigate = useNavigate();
  // Fetch HR data
  useEffect(() => {
    const fetchHrData = async () => {
      try {
        const response = await axios.get("https://backend.ems.uk.hiradentallab.com/api/user/hr");
        setHrData(response.data);
        setFilteredHrData(response.data); // Initially display all data
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchHrData();
  }, []);
  // Fetch timing data
  useEffect(() => {
    const fetchTimingData = async () => {
      try {
        const response = await axios.get(
          "https://backend.ems.uk.hiradentallab.com/api/timings/getAllTimings"
        );
        const timings = response.data.reduce((acc, timing) => {
          acc[timing.userId] = timing;
          return acc;
        }, {});
        setTimingData(timings);
      } catch (error) {
        console.error("Error fetching timing data:", error);
        setError("Failed to load timing data.");
      }
    };
    fetchTimingData();
  }, []);
  // Handle search with debounce
  const handleSearch = useCallback(
    _.debounce(async (query) => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `https://backend.ems.uk.hiradentallab.com/api/user/hr/search?query=${query}`
        );
        setFilteredHrData(response.data);
      } catch (err) {
        console.error("Error during search:", err);
        setError("Search failed.");
      } finally {
        setIsLoading(false);
      }
    }, 300), // Debounce delay of 300ms
    []
  );
  const onSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    handleSearch(query);
  };
  // Pagination logic
  const paginatedData = filteredHrData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const totalEntries = filteredHrData.length;
  const totalPages = Math.ceil(totalEntries / rowsPerPage);
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };
  const pageRange = () => {
    const pages = [];
    let startPage = Math.max(currentPage - 1, 1);
    let endPage = Math.min(startPage + 2, totalPages);
    if (endPage - startPage < 2) {
      startPage = Math.max(endPage - 2, 1);
    }
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };
  if (isLoading) {
    return <Spinner animation="border" variant="primary" />;
  }
  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }
  const handleAddClick = (hr) => {
    setSelectedHr(hr); // Use selectedHr state
    setShowModal(true); // Close the modal before navigating
    navigate(`/hr-timing/${hr.userId}`, {
      state: { selectedUserId: hr.userId, shift: timingData[hr.userId]?.shift },
    });
  };
  const handleEditClick = (hr) => {
    setSelectedHr(hr); // Use selectedHr state
    setShowModal(true); // Close the modal before navigating
    navigate(`/edit-hr-timing/${hr.userId}`, {
      state: { selectedUserId: hr.userId, shift: timingData[hr.userId]?.shift },
    });
  };
  const handleViewClick = (hr) => {
    setSelectedHr(hr);
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  if (isLoading) {
    return (
      <Spinner
        animation="border"
        variant="primary"
        className="loading-spinner"
      />
    );
  }
  if (error) {
    return <Alert variant="danger">Error fetching HR data: {error}</Alert>;
  }
  return (
    <div className="container-fluid">
      <h1 className="hr-schedule-title">
        <FaUserClock /> HR Schedule
      </h1>
      <hr />
      <h1 className="hr-schedule-subtitle">
        <FaUsers /> HR's
      </h1>
      <hr />
      <div className="hr-schedule-content">
        <div>
          <div className="filter-container">
            <Col xs={12} md={6} className="filter-left">
              <Dropdown className="d-inline mx-2" autoClose="inside">
                <Dropdown.Toggle id="dropdown-autoclose-inside">
                  Show Entries
                </Dropdown.Toggle>
                <Dropdown.Menu className="custom-dropdown-menu">
                  <Dropdown.Item href="#">15</Dropdown.Item>
                  <Dropdown.Item href="#">25</Dropdown.Item>
                  <Dropdown.Item href="#">50</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col xs={12} md={6} className="filter-right">
            <Form >
              <Form.Control
                type="search"
                placeholder="Search by name"
                value={searchQuery}
                onChange={onSearchChange}
              />
            </Form>
            </Col>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead className="table-header">
                <tr className="hr-schedule-table-header">
                  <th>SR</th>
                  <th>HR Name</th>
                  <th>Department</th>
                  <th>Shift</th>
                  <th>Check-In Time</th>
                  <th>Check-Out Time</th>
                  <th>Working Hours</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((hr, index) => (
                  <tr className="table-row" key={hr._id}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{hr.name}</td>
                    <td>{hr.department?.name || "N/A"}</td>
                    <td>{timingData[hr.userId]?.shift || "Not Set"}</td>
                    <td>{timingData[hr.userId]?.shiftStart}</td>
                    <td>{timingData[hr.userId]?.shiftEnd}</td>
                    <td>{timingData[hr.userId]?.totalHours}</td>
                    <td>
                      <Button
                       variant="success"
                        size="sm"
                        onClick={() => handleAddClick(hr)}
                      >
                        <IoMdAdd />
                      </Button>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => handleViewClick(hr)}
                      >
                        <IoEye />
                      </Button>
                      <Button
                       variant="warning"
                        size="sm"
                        onClick={() => handleEditClick(hr)}
                        style={{marginLeft:"8px"}}
                      >
                        <FaRegEdit />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="table-footer">
                <tr className="hr-schedule-table-footer">
                  <td>Total</td>
                  <td>{totalEntries}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
            <div className="entries-pagination-container">
              <p className="showing-entries">
                Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                {Math.min(currentPage * rowsPerPage, totalEntries)} of{" "}
                {totalEntries} entries
              </p>

              <nav className="pagination-container">
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <Button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage - 1)}
                    >
                      Previous
                    </Button>
                  </li>
                  {pageRange().map((pageNumber) => (
                    <li
                      className={`page-item ${
                        pageNumber === currentPage ? "active" : ""
                      }`}
                      key={pageNumber}
                    >
                      <Button
                        className="page-link"
                        onClick={() => handlePageChange(pageNumber)}
                      >
                        {pageNumber}
                      </Button>
                    </li>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <Button
                      className="page-link"
                      onClick={() => handlePageChange(currentPage + 1)}
                    >
                      Next
                    </Button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal}onHide={handleClose}centered size="sm"dialogClassName="fancy-modal">
        <Modal.Header closeButton>
          <Modal.Title>HR Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedHr && (
            <div>
              <h4>Name: {selectedHr.name}</h4>
              <p>UserId: {selectedHr.userId}</p>
              <p>Department: {selectedHr.department?.name || "N/A"}</p>
              <p>Shift: {timingData[selectedHr.userId]?.shift || "N/A"}</p>
              <p>Check-In Time:{" "}{timingData[selectedHr.userId]?.shiftStart || "N/A"}</p>
              <p>Check-Out Time:{" "}{timingData[selectedHr.userId]?.shiftEnd || "N/A"}</p>
              <p>Break-In: {timingData[selectedHr.userId]?.breakStart || "N/A"}</p>
              <p>Break-Out: {timingData[selectedHr.userId]?.breakEnd || "N/A"}</p>
              <p>Working Hours:{" "}{timingData[selectedHr.userId]?.totalHours || "N/A"}  </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
